export enum NaturalPersonFormFieldNames {
  TaxResidenceCountryId = 'taxResidenceCountryId',
  IsPPE = 'isPPE',
  IsFPE = 'isFPE',
}
